import styled from '@emotion/styled'
import { spacing } from 'main/ui'

export const DetailedPricingTableContainer = styled.div`
  margin-top: ${spacing.minorScale(5)}px;
`
